import { render, staticRenderFns } from "./inventory-ring.vue?vue&type=template&id=3ddf17f2&scoped=true&"
import script from "./inventory-ring.vue?vue&type=script&lang=js&"
export * from "./inventory-ring.vue?vue&type=script&lang=js&"
import style0 from "./inventory-ring.vue?vue&type=style&index=0&id=3ddf17f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf17f2",
  null
  
)

export default component.exports